import { type RVTask } from "@regal-voice/shared-types";
import { Typography } from "antd";
import { clsx } from "clsx";

import { RVLiveTimeDisplay, RVTimeDisplay } from "@regal-voice/ui";

import { useTaskStatusDisplay } from "./hooks/useTaskStatusDisplay";

import styles from "./RVTaskStatus.module.scss";

type FactoryProps = {
    task?: RVTask;
    useBarVariant?: boolean;
};

export function RVTaskStatus({ task, useBarVariant }: FactoryProps): JSX.Element {
    const { statusDisplay, timeDisplay, shouldShowLiveTime, shouldShowPendingTime } = useTaskStatusDisplay({
        task,
        useBarVariant,
    });
    return (
        <div
            className={clsx(styles.metaSpan, {
                [styles.barStyle]: useBarVariant,
            })}
        >
            {statusDisplay && <Typography.Text>{statusDisplay}</Typography.Text>}

            {statusDisplay && (shouldShowLiveTime || shouldShowPendingTime) && (
                <Typography.Text>{" | "}</Typography.Text>
            )}

            {shouldShowPendingTime && (
                <RVTimeDisplay time={timeDisplay} position="right" key={`${task?.sid}-time-display`} />
            )}

            {shouldShowLiveTime && <RVLiveTimeDisplay startTime={timeDisplay} />}
        </div>
    );
}
